import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["alert", "alertMessage", "alertList"];

  static values = {
    url: String,
    redirect: String,
    method: String, // "POST" | "PUT"
  };

  connect() {
    this.hideAlert();
  }

  submit(event) {
    event.preventDefault();

    const token = this.csrfToken();
    const url = this.urlValue || this.element.getAttribute("action") || "";
    const method = (this.methodValue || this.element.getAttribute("method") || "POST").toUpperCase();

    // mantém exatamente o padrão antigo (?authenticity_token=...)
    const finalUrl = token ? `${url}?&authenticity_token=${encodeURIComponent(token)}` : url;

    const data = new FormData(this.element);

    this.hideAlert();
    this.clearAlertContent();

    fetch(finalUrl, {
      method,
      body: data,
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(async (resp) => {
        if (resp.ok) return resp.json();
        const json = await resp.json().catch(() => null);
        throw { resp, json };
      })
      .then((_result) => {
        const redirectTo = this.redirectValue || finalUrl;
        window.location.replace(redirectTo);
      })
      .catch((err) => {
        const json = err && err.json ? err.json : null;
        const erros = (json && json.erros) ? json.erros : [];
        const mensagem = (json && json.mensagem)
          ? json.mensagem
          : "Falha ao salvar. Verifique os campos.";

        this.renderAlert(mensagem, erros);
      });
  }

  csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute("content") : "";
  }

  hideAlert() {
    if (this.hasAlertTarget) this.alertTarget.classList.add("hidden");
  }

  showAlert() {
    if (this.hasAlertTarget) this.alertTarget.classList.remove("hidden");
  }

  clearAlertContent() {
    if (this.hasAlertMessageTarget) this.alertMessageTarget.textContent = "";
    if (this.hasAlertListTarget) this.alertListTarget.innerHTML = "";
  }

  renderAlert(message, errors) {
    if (this.hasAlertMessageTarget) this.alertMessageTarget.textContent = message;

    if (this.hasAlertListTarget) {
      const html = (errors || [])
        .map((e) => `<li>${this.escapeHtml(e)}</li>`)
        .join("");
      this.alertListTarget.innerHTML = html;
    }

    this.showAlert();
    this.scrollToAlert();
  }

  scrollToAlert() {
    if (!this.hasAlertTarget) return;
    this.alertTarget.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  escapeHtml(str) {
    return (str || "").toString()
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }
}
